import { useEffect, useState } from "react";
import CatService from "../../../service/CatService";
import ScrService from "../../../service/ScrService";
import FilterBox from "../../common/FilterBox";
import { appTypesAll, examStatusesAll } from "../const";
import OrgService from "../../../service/OrgService";
import { InputText } from "primereact/inputtext";
import TestGrid from "./TestGrid";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Form } from "../../common/Form";
import { CommonDialog } from "../../common/CommonDialog";
import { useParams } from "react-router-dom";
import { ToggleButton } from "primereact/togglebutton";

export function TestSearchPage(){
    let {sectionSelect} = useParams();
    const onTestSelect=()=>{}
    const onSectSelect=()=>{}
    return(
        <Card className="col-8">
            <TestSearch sectionSelect={sectionSelect} onTestSelect={onTestSelect} onSectSelect={onSectSelect}></TestSearch>
        </Card>
    )
}
export function TestSearch({sectionSelect,onTestSelect,onSectSelect,selectionMode})
{
    const [typeCodes,setTypeCodes]=useState([]);
    const [testYears,setTestYears]=useState([]);
    const [orgs,setOrgs]=useState([]);
    const [crss,setCrss]=useState([]);
    const [terms,setTerms]=useState([]);
    const [key,setKey]=useState(null);
    const [tests,setTests]=useState([]);
    const [selection,setSelection]=useState([]);
    const [advanced,setAdvanced]=useState(false);
    const [sections,setSections]=useState([]);
    const [sect,setSect]=useState({sect:null});

    const [fb,setFb]=useState({term:1,examType:'ALL',status:'ALL',appType:'ALL',year:'ALL',org:0,crs:0});

    const retrieveTypeCodes=()=>{
        CatService.getUdfByEntity('ALL').then((udfs)=>{
            udfs.forEach(udf => {
                if(udf.name=='examTypeCode')
                {
                    const tc = udf.options.map((option)=>{return {label:option,value:option}});
                    setTypeCodes([{label:'ALL',value:'ALL'},...tc]);
                }
            });
        });
    }    
    const retrieveTestYears=()=>{
        ScrService.searchTestYears(0).then((years)=>{
            const ty = years.map((yr)=>{return {label:yr,value:yr}});
            setTestYears([{label:'ALL',value:'ALL'},...ty]);
        });
    }
    const retrieveOrgs=()=>{
        OrgService.getOrgs().then((orgs)=>{
            const sch = orgs.map((org)=>{return {label:org.name,value:org.id}});
            setOrgs([{label:'ALL',value:0},...sch]);
        });
    }
    const retrieveCrss=(termId,orgId)=>{
        if(orgId == 0)
        {
            setCrss([{label:'ALL',value:0}]);
            return;
        }    
        OrgService.getCrss(orgId,termId).then((crss)=>{
            const cr = crss.map((crs)=>{return {label:crs.name,value:crs.id}});
            setCrss([{label:'ALL',value:0},...cr]);
        });
    }
    const retrieveTerms=()=>{
        OrgService.getTerms().then((terms)=>{
            const tr = terms.map((term)=>{return {label:term.name,value:term.id}});
            setTerms(tr);
        });
    }
    const retrieveActiveTerm=()=>{
        OrgService.getActiveTerm().then((term)=>{
            onTermChange('term',term.id);
        });
    }
    const onFilterBarChange=(inputId,val)=>{
        var fbn={...fb};
        fbn[inputId] = val;
        setFb(fbn);
    }

    const onOrgChange=(inputId,val)=>{
        var fbn={...fb};
        fbn.org=val;
        setFb(fbn);
        retrieveCrss(fb.term,val);
    }
    const onTermChange=(inputId,val)=>{
        var fbn={...fb};
        fbn.term=val;
        setFb(fbn);
        if(fb.org!=0)
            retrieveCrss(val,fb.org);
    }
    const searchTests=()=>{
        var query={...fb,key:key};
        ScrService.getTestsByOrg(fb.org,query).then((ret)=>{
            setTests(ret);
        });
    }
    const onKeyChange=(e)=>{
        setKey(e.target.value);
    }
    const onSearchKey=(e)=>{
        if(e.keyCode == 13)
            searchTests();
    }    
    const onSelectionChange=(e)=>{
        setSelection(e.value);
        if(sectionSelect)
        {
            ScrService.getSects(e.value.id).then((ss)=>{
                setSections(ss);
            });    
        }
        onTestSelect(e.value);
    }
    const onToggleAdvanced=()=>{
        setAdvanced(!advanced);
    }
    const onSectChange=(formData)=>{
        setSect(formData);
        onSectSelect(formData.sect);
    }
    useEffect(()=>{
        retrieveTestYears();
        retrieveTypeCodes();
        retrieveOrgs();
        retrieveTerms();
        retrieveActiveTerm();
    },[])
    return(
        <>
            <div className="flex flex-column gap-4">
            <div className="flex flex-wrap align-items-center gap-2">
                <div className="p-inputgroup">
                    <InputText placeholder="Keyword" onChange={onKeyChange} onKeyUp={onSearchKey}/>
                    <Button icon="pi pi-search" className="p-button-secondary" onClick={searchTests}/>
                </div>
                <Button severity="secondary" label="Advanced Search" icon="pi pi-chevron-down" onClick={onToggleAdvanced}></Button>
            </div>
            <div className={advanced?'flex flex-wrap align-items-center gap-2':'hidden'}>
                <FilterBox inputId="term" items={terms} value={fb.term} label="Term" onChange={onTermChange}/>
                <FilterBox inputId="org" items={orgs} value={fb.org} label="School" onChange={onOrgChange}/>
                <FilterBox inputId="crs" items={crss} value={fb.crs} label="Course" onChange={onFilterBarChange}/>
                <FilterBox inputId="examType" items={typeCodes} value={fb.examType} label="Type" onChange={onFilterBarChange}/>
                <FilterBox inputId="status" items={examStatusesAll} value={fb.status} label="Status" onChange={onFilterBarChange}/>
                <FilterBox inputId="appType" items={appTypesAll} value={fb.appType} label="Application" onChange={onFilterBarChange}/>
                <FilterBox inputId="year" items={testYears} value={fb.year} label="Year" onChange={onFilterBarChange}/>
                <Button onClick={searchTests} label="Search..." icon="pi pi-search"></Button>
            </div>
            <div>
                <DataTable value={tests} striped size="small" selectionMode={'single'} dataKey="id" showGridlines selection={selection}
                    onSelectionChange={onSelectionChange} scrollHeight="300px" scrollable> 
                    {
                        selectionMode=='multiple'?
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} showFilterMenu={true}></Column>:''
                    }
                    <Column field="id" header="Id" style={{width:'5%'}} sortable></Column>
                    <Column field="name" header="Name" style={{width:'30%',minWidth:'250px'}} sortable></Column>
                    <Column field="typeCode" header="Type" style={{width:'10%'}} sortable filter></Column>
                    <Column field="testNo" header="Short name" style={{width:'10%'}} sortable></Column>
                    <Column field="status" header="Status" style={{width:'5%'}} sortable></Column>
                    <Column field="testDate" header="Date" style={{width:'10%',minWidth:'80px'}} sortable></Column>
                    <Column field="cat" header="Category" style={{width:'25%',minWidth:'200px'}} sortable></Column>
                </DataTable>
            </div>
            <div className={sectionSelect?'':'hidden'}>
                <Form id="sect" formData={sect} columns="1" onChange={onSectChange} fields={[
                    {id:"sect",ftype:"dropdown",field:"sect",label:"Section",options:sections,optionLabel:"name",optionValue:"id"}
                ]}/>
            </div>
            </div>
        </>
    )
}
export function TestSearchPane({onSelect})
{
    const [typeCodes,setTypeCodes]=useState([]);

    const [fb,setFb]=useState({examType:'ALL'});

    const retrieveTypeCodes=()=>{
        CatService.getUdfByEntity('ALL').then((udfs)=>{
            udfs.forEach(udf => {
                if(udf.name=='examTypeCode')
                {
                    const tc = udf.options.map((option)=>{return {label:option,value:option}});
                    setTypeCodes([{label:'ALL',value:'ALL'},...tc]);
                }
            });
        });
    }    
    const onFilterBarChange=(inputId,val)=>{
        var fbn={...fb};
        fbn[inputId] = val;
        setFb(fbn);
        onSelect(fbn);
    }

    useEffect(()=>{
        retrieveTypeCodes();
    },[])
    return(
        <>
            <div className='flex flex-wrap align-items-center gap-2'>
                <FilterBox inputId="examType" items={typeCodes} value={fb.examType} label="Type" onChange={onFilterBarChange}/>
            </div>
        </>
    )
}

export function TestSearchDialog({visible,sectionSelect,onOK,onCancel})
{
    const [test,setTest]=useState(null);
    const [sect,setSect]=useState(null);

    const onTestSelect=(tst)=>{setTest(tst)}
    const onSectSelect=(se)=>{setSect(se)}
    const _onOK=()=>{onOK(test.id,sect)}
    const _onCancel=()=>{onCancel()}

    return(
        <CommonDialog header="Test Search" visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div style={{width:'600px',height:'600px'}}>
                <TestSearch sectionSelect={sectionSelect} onSectSelect={onSectSelect} onTestSelect={onTestSelect}></TestSearch>
            </div>
        </CommonDialog>
    )    
}